module.exports = __webpack_public_path__ + "static/media/icon_pencil.6d063d2c.svg";